import React from 'react';

import styled from 'styled-components';

import Icon from 'common/Icons/Icon';
import Button from 'components/lib/Button';
import Dropdown from 'components/lib/Dropdown';

import { STATUS } from '../../constants';

const Container = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 10px;
`;

const CreateActions = styled.div`
  display: flex;
  align-items: stretch;
`;

const CreatePrimaryButton = styled(Button)`
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
`;

const CreateDropdownButton = styled(Button)`
  min-width: 34px;
  padding-left: 8px;
  padding-right: 8px;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  border-left: 1px solid rgba(255, 255, 255, 0.35);
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
  color: var(--white);
`;

type Props = {
  isEditMode: boolean;
  onClose: () => void;
  onSubmit: (sendInvite?: boolean) => void;
  status: string;
  disableSubmit?: boolean;
};

const UserManagementUserModalFooter = ({ isEditMode, onClose, onSubmit, status, disableSubmit = false }: Props) => {
  const createActionMenuItems = [
    {
      label: <span data-test-id="user-management-create-send-invite">Create & Send Invite</span>,
      key: 'create-send-invite',
      onClick: () => onSubmit(true),
    },
  ];

  return (
    <Container>
      <Button onClick={onClose} disabled={status === STATUS.LOADING} data-test-id="user-management-modal-cancel">
        Cancel
      </Button>
      {isEditMode ? (
        <Button
          type="primary"
          onClick={() => onSubmit()}
          loading={status === STATUS.LOADING}
          disabled={disableSubmit || status === STATUS.LOADING}
          data-test-id="user-management-modal-save"
        >
          Save
        </Button>
      ) : (
        <CreateActions>
          <CreatePrimaryButton
            type="primary"
            onClick={() => onSubmit()}
            loading={status === STATUS.LOADING}
            data-test-id="user-management-modal-create"
          >
            Create
          </CreatePrimaryButton>
          <Dropdown menu={{ items: createActionMenuItems }} trigger={['click']} placement="bottomRight">
            <CreateDropdownButton
              type="primary"
              disabled={status === STATUS.LOADING}
              data-test-id="user-management-modal-create-menu"
            >
              <Icon src="/icons/dropdown-caret-down-white.svg" size={12} />
            </CreateDropdownButton>
          </Dropdown>
        </CreateActions>
      )}
    </Container>
  );
};

export default UserManagementUserModalFooter;
